import { RouteInfo } from './sidebar.metadata';

export const ROUTES: RouteInfo[] = [
    // {
    //     path: '/pages/tenantchanging', title: 'SuperAdmin', icon: 'ft-home',
    //     class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: []
    // },
    {
        identifier: 'dashboard',
        path: 'dashboard',
        title: 'Dashboard',
        icon: 'icon-dashboard',
        class: '',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: [],
        isDisabled: false,
        pageid: '1'
    },

    {
        identifier: 'usermanagement',
        path: '/users',
        title: 'User Management',
        icon: 'icon-login-user',
        class: '',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: [],
        isDisabled: false,
        pageid: '2'
    },
    // {
    //     identifier: 'contentmanagement', path: '/content', title: 'Content Management', icon: 'ft-file-text',
    //     class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: []
    // },
    {
        identifier: 'contentmanagement',
        path: '',
        title: 'Content Management',
        icon: 'ft-align-left',
        class: 'has-sub',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: [
            {
                identifier: 'contentmanagement',
                path: '/content',
                title: 'Library Content',
                icon: 'librarycontent',
                class: '',
                badge: '',
                badgeClass: '',
                isExternalLink: true,
                submenu: [],
                isDisabled: false,
                pageid: '3'
            },
            {
                identifier: 'contentmanagement',
                path: '/content-structure',
                title: 'Publisher Repo',
                icon: 'publisherrepo',
                class: '',
                badge: '',
                badgeClass: '',
                isExternalLink: true,
                submenu: [],
                isDisabled: false,
                pageid: '4'
            },
            // {
            //   identifier: 'contentmanagement',
            //   path: '/adaptive-assessment',
            //   title: 'Adaptive Assessment <small>[beta]</small>',
            //   icon: 'adaptiveassessment',
            //   class: '',
            //   badge: '',
            //   badgeClass: '',
            //   isExternalLink: true,
            //   submenu: [],
            //   isDisabled: true
            // },
            {
                identifier: 'storyboard',
                path: '/storyboard',
                title: 'Storyboard <small>[beta]</small>',
                icon: 'storyboard',
                class: '',
                badge: '',
                badgeClass: '',
                isExternalLink: true,
                submenu: [],
                isDisabled: false,
                pageid: '10'
            },
            {
                identifier: 'youtubecourse',
                path: '/youtube-course',
                title: 'Youtube Course',
                icon: 'youtubecourse',
                class: '',
                badge: '',
                badgeClass: '',
                isExternalLink: true,
                submenu: [],
                isDisabled: false,
                pageid: '11'
            },
        ],
        isDisabled: false,
        pageid: ''
    },
    // {
    //     identifier: 'reports', path: '/reports', title: 'Reports', icon: 'icon-bar-chart',
    //     class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: []
    // },
  {
        identifier: 'medialibrary',
        path: '',
        title: 'Media Library',
        icon: 'medialib',
        class: 'has-sub',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: [
            {
                identifier: 'medialibrary',
                path: '/my-library',
                title: 'My Library',
                icon: 'mylib',
                class: '',
                badge: '',
                badgeClass: '',
                isExternalLink: true,
                submenu: [],
                isDisabled: false,
                pageid: '12.1'
            },
            {
                identifier: 'medialibrary',
                path: '/global-library',
                title: 'SkillFLO Library',
                icon: 'globallib',
                class: '',
                badge: '',
                badgeClass: '',
                isExternalLink: true,
                submenu: [],
                isDisabled: false,
                pageid: '12.2'
            },         
        ],
        isDisabled: false,
        pageid: '12'
    },   
    {
        identifier: 'billing',
        path: '/billing',
        title: 'Billing <small>[beta]</small>',
        icon: 'billing',
        class: '',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: [],
        isDisabled: false,
        pageid: '13'
    },
    {
        identifier: 'settings',
        path: '/admin-settings',
        title: 'Widget Manager',
        icon: 'icon-settings',
        class: '',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: [],
        isDisabled: false,
        pageid: '6'
    },
    {
        identifier: 'Reports',
        path: '',
        title: 'Reports',
        icon: 'icon-bar-chart',
        class: 'has-sub',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: [
            {
                identifier: 'Reports',
                path: '/analytics-report',
                title: 'Analytics',
                icon: 'analytics',
                class: '',
                badge: '',
                badgeClass: '',
                isExternalLink: true,
                submenu: [],
                isDisabled: false,
                pageid: '7.1'
            },
            {
                identifier: 'Reports',
                path: '/metrics-report',
                title: 'Metrics',
                icon: 'icon-bar-chart',
                class: '',
                badge: '',
                badgeClass: '',
                isExternalLink: true,
                submenu: [],
                isDisabled: false,
                pageid: '7.4'
            },            
            {
                identifier: 'Reports',
                path: '/reports',
                title: 'Statements',
                icon: 'statement',
                class: '',
                badge: '',
                badgeClass: '',
                isExternalLink: true,
                submenu: [],
                isDisabled: false,
                pageid: '7.2'
            },
            {
                identifier: 'Reports',
                path: '/audit-logs',
                title: 'Audit Logs',
                icon: 'auditlogs',
                class: '',
                badge: '',
                badgeClass: '',
                isExternalLink: true,
                submenu: [],
                isDisabled: false,
                pageid: '7.3'
            },
        ],
        isDisabled: false,
        pageid: '7'

    },
    {
        identifier: 'tasks',
        path: '/task-management',
        title: 'Task Manager',
        icon: 'taskmanager',
        class: '',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: [],
        isDisabled: false,
        pageid: '8'
    },
    {
        identifier: 'themechange',
        path: '/theme-change',
        title: 'Theme Settings <small>[beta]</small>',
        icon: 'themesetting',
        class: '',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: [],
        isDisabled: false,
        pageid: '9'
    },
    {
        identifier: 'help',
        path: '/help',
        title: 'Help',
        icon: 'help-icon-2',
        class: '',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: [],
        isDisabled: false,
        pageid: '14'
    },
     {
    identifier: 'support',
    path: '/support',
    title: 'Support',
    icon: 'ft-life-buoy',
    class: '',
    badge: '',
    badgeClass: '',
    isExternalLink: false,
    submenu: [],
    isDisabled: false,
    pageid: '15',
  },
    // {
    //     identifier: 'progressTracker',
    //     path: '/progresstracker',
    //     title: 'progressTracker',
    //     icon: 'progressTracker',
    //     class: '',
    //     badge: '',
    //     badgeClass: '',
    //     isExternalLink: false,
    //     submenu: [],
    //     isDisabled: false,
    //     pageid: '14'
    // },

    // {
    //     identifier: 'courseassignment', path: '/course-assignment', title: 'Assign Courses to Roles', icon: 'fa fa-book',
    //     class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: []
    // },
    // {
    //     identifier: 'contentmanagement',path: '', title: 'Content Management', icon: 'ft-align-left', class: 'has-sub',
    //     badge: '', badgeClass: '',
    //     isExternalLink: false,
    //     submenu: [
    //         {
    //             identifier: 'reusablecontent',path: '/content', title: 'Library Content', icon: 'ft-layers', class: '',
    //             badge: '', badgeClass: '', isExternalLink: true, submenu: []
    //         },
    //         {
    //             identifier: 'contentstructure',path: '/', title: 'Publisher Repo', icon: 'ft-move', class: '',
    //             badge: '', badgeClass: '', isExternalLink: true, submenu: []
    //         },
    //     ]
    // },

    // {
    //     path: '/pages/scenario', title: 'Scenarios', icon: 'icon-pie-chart',
    //     class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: []
    // },

    // {
    //     path: '/pages/assetmanage', title: 'Assets', icon: 'icon-paper-clip',
    //     class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: []
    // },
    // {
    //     path: '/pages/scenemanage', title: 'Scenes', icon: 'ft-film',
    //     class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: []
    // },
    // {
    //     path: '/pages/audiomanage', title: 'Audio', icon: 'ft-speaker',
    //     class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: []
    // },
    // {
    //     path: '/pages/labmanage', title: 'Labs', icon: 'ft-monitor',
    //     class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: []
    // },
    // {
    //     path: '/pages/appmanage', title: 'App Builds', icon: 'ft-download-cloud',
    //     class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: []
    // },
    // {
    //     path: '/pages/report', title: 'Reports', icon: 'icon-bar-chart',
    //     class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: []
    // },
    // {
    //     path: '/pages/tenantmanage', title: "Tenants", icon: 'ft-list',
    //     class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: []
    // },

    // {
    //     path: '', title: 'Menu Levels', icon: 'ft-align-left', class: 'has-sub',
    //     badge: '1', badgeClass: 'badge badge-pill badge-danger float-right mr-1 mt-1',
    //     isExternalLink: false,
    //     submenu: [
    //         {
    //             path: 'javascript:;', title: 'Second Level', icon: '', class: '',
    //             badge: '', badgeClass: '', isExternalLink: true, submenu: []
    //         },
    //         {
    //             path: '', title: 'Second Level Child', icon: '', class: 'has-sub',
    //             badge: '', badgeClass: '', isExternalLink: false,
    //             submenu: [
    //                 {
    //                     path: 'javascript:;', title: 'Third Level 1.1', icon: '',
    //                     class: '', badge: '', badgeClass: '', isExternalLink: true, submenu: []
    //                 },
    //                 {
    //                     path: 'javascript:;', title: 'Third Level 1.2', icon: '',
    //                     class: '', badge: '', badgeClass: '', isExternalLink: true, submenu: []
    //                 },
    //             ]
    //         },
    //     ]
    // },
    // {
    //     path: '/changelog', title: 'ChangeLog', icon: 'ft-file', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: []
    // },
    // {
    //     path: 'https://pixinvent.com/apex-angular-4-bootstrap-admin-template/documentation',
    //     title: 'Documentation', icon: 'ft-folder', class: '', badge: '', badgeClass: '', isExternalLink: true, submenu: []
    // },
    // {
    //     path: 'https://pixinvent.ticksy.com/', title: 'Support', icon: 'ft-life-buoy',
    //     class: '', badge: '', badgeClass: '', isExternalLink: true, submenu: []
    // },
];
